import { requestArgoForMarkerData } from "@/argo_ar/ArgoUtils";
import { Marker } from "@/models/Marker";

let instance: MarkerService = null;

class MarkerService {
    private pageId: number;
    private marker: Marker;

    public reset() {
        this.marker = null;
        this.pageId = -1;
    }

    public async loadMarker(pageId, deviceId = "") {
        if (this.marker && pageId === this.pageId) {
            return this.marker;
        }

        const markerString: string = (await requestArgoForMarkerData(pageId, deviceId)) as string;
        const marker = JSON.parse(markerString) as Marker;

        this.marker = marker;
        this.pageId = pageId;

        return marker;
    }
}

export default function getInstance(): MarkerService {
    if (!instance) {
        instance = new MarkerService();
    }

    return instance;
}
